import type { RideInput } from './model';

// Fixed 60 Hz, run-length encoded controls. No client positions or points are trusted.
export type InputSegment = [frames: number, mask: number, trick: number];
export const MAX_RACE_FRAMES = 60 * 15 * 60;
export const MAX_SEGMENTS = 16000;
export function encodeInput(input: RideInput): [number, number] {
  return [(input.steer < 0 ? 1 : input.steer > 0 ? 2 : 0) | (input.brake ? 4 : 0) | (input.sprint ? 8 : 0) | (input.jump ? 16 : 0) | (input.coast ? 32 : 0), input.trick ?? 0];
}
export function decodeInput(mask: number, trick: number): RideInput {
  return { steer: mask & 1 ? -1 : mask & 2 ? 1 : 0, brake: !!(mask & 4), sprint: !!(mask & 8), jump: !!(mask & 16), coast: !!(mask & 32), trick };
}
export class RaceRecorder {
  segments: InputSegment[] = [];
  frames = 0;
  eligible = true;
  record(input: RideInput) {
    if (!this.eligible) return;
    const [mask, trick] = encodeInput(input), last = this.segments.at(-1);
    this.frames++;
    if (last && last[1] === mask && last[2] === trick) last[0]++;
    else this.segments.push([1, mask, trick]);
    if (this.frames > MAX_RACE_FRAMES || this.segments.length > MAX_SEGMENTS) this.eligible = false;
  }
}
